import { render, staticRenderFns } from "./EntriesPanel.vue?vue&type=template&id=2f40232d&scoped=true"
import script from "./EntriesPanel.vue?vue&type=script&lang=js"
export * from "./EntriesPanel.vue?vue&type=script&lang=js"
import style0 from "./EntriesPanel.vue?vue&type=style&index=0&id=2f40232d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40232d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})
